import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Body3, Body4 } from '../../text/Text';
import style from './EditableTableField.module.css';

export const EditableTableField = ({
  initialValue,
  updateValue,
  color,
  inputType,
  backgroundColor,
  bodySize,
  disabled,
  margin,
}) => {
  const [inputValue, setInputValue] = useState(initialValue);
  const [editing, setEditing] = useState(false);
  const focusRef = useRef();
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);
  
  return (
    <div
      className={style.div}
      style={{ margin, width: '80%' }}
      onClick={() => {
        setEditing((prev) => !prev);
        const timer = setTimeout(() => {
          if (focusRef.current !== null) {
            focusRef.current.focus();
          }
        }, 50);
        timeoutRef.current = timer;
      }}
    >
      <>
        {editing ? (
          <input
            disabled={disabled}
            style={{
              fontSize: bodySize === 4 ? '0.579rem' : ' 0.694rem',
              backgroundColor,
              color,
            }}
            ref={focusRef}
            type={inputType}
            className={style.input}
            onChange={({ target }) => setInputValue(target.value)}
            onBlur={() => {
              if (inputValue !== 0 && inputValue !== '')
                updateValue(inputValue);
              else setInputValue(initialValue);
              setEditing(false);
            }}
          />
        ) : bodySize === 4 ? (
          <Body4 fontWeight={600} color={color}>
            {initialValue}
          </Body4>
        ) : (
          <Body3 fontWeight={600} color={color}>
            {initialValue}
          </Body3>
        )}
      </>
    </div>
  );
};

EditableTableField.propTypes = {
  backgroundColor: PropTypes.string,
  bodySize: PropTypes.number,
  color: PropTypes.string,
  initialValue: PropTypes.any,
  inputType: PropTypes.string,
  updateValue: PropTypes.func,
  disabled: PropTypes.bool,
  margin: PropTypes.string,
};
